<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style lang="scss">
.input-wdt {
  width: 100%;
}
.level-inner-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.level-inner-wrap .select-level-drop {
  width: 70%;
  margin-right: 15px;
}
.create-category {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.create-category .input-wdt2 {
  width: 80%;
  margin-right: 15px;
}
.con-img-upload {
  background: #efebeb;
}
.ql-container.ql-snow {
  min-height: 150px;
}
.profile-edit .ql-editor {
  min-height: 150px;
}
.profile-edit {
  display: flex;
}
.profile-edit .unlayer-editor {
  width: 100%;
}
.countDivder {
  margin: 30px 0 0;
}
.rqrd {
  color: #f00;
}
.mail-tmplt-btns {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mail-tmplt-btns a {
  position: relative;
  font-weight: 500;
  font-size: 14px;
  color: #4c8af6;
  cursor: pointer;
  border: 1px solid #4c8af6;
  display: inline-block;
  padding: 4px 12px;
}
.off-after {
  border-radius: 0 4px 4px 0;
  border-left: none !important;
}
.right-off-radius {
  border-radius: 4px 0 0 4px;
}
.mail-tmplt-btns label {
  font-size: 16px;
  font-weight: 16px;
}
</style>
<template>
  <div id="mailtpl-edit-tab-account">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>Template Name <span class="rqrd" v-if="!$route.params.DocName && !$route.params.CollectionName">*</span></label>
        <div class="mt-2 h3" v-if="$route.params.DocName && $route.params.CollectionName">{{ data_local.TemplateName }}</div>
        <vs-input
          v-if="!$route.params.DocName && !$route.params.CollectionName"
          class="inputx w-full"
          name="Template Name"
          v-model="data_local.TemplateName"
          @blur="checkTemplateExists"
          v-validate="{required: true, alpha_num: true, max:30}"
        />
        <span class="text-danger text-sm" v-show="!$route.params.DocName && !$route.params.CollectionName && errors.has('Template Name')">{{errors.first("Template Name")}}</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>
          From Email
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="inputx w-full"
          name="From Email"
          :disabled="disableFromEmail && $route.params.DocName && $route.params.CollectionName"
          v-model="data_local.from"
          v-validate="'required|email'"
        />
        <span class="text-danger text-sm" v-show="errors.has('From Email')">{{errors.first("From Email")}}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>
          From Name
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="inputx w-full"
          name="From Name"
          v-model="data_local.fromName"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('From Name')">This field is required</span>
      </div>
      <div class="vx-col md:w-7/12 w-full mt-2">
        <label>
          Subject
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="inputx w-full"
          name="Subject"
          v-model="data_local.subject"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Subject')">{{
          errors.first("Subject")
        }}</span>
      </div>

      <div class="vx-col md:w-5/12 w-full mt-2">
        <label>Reply-to Email</label>
        <vs-input
          class="inputx w-full"
          name="To"
          v-model="data_local.to"
          v-validate="'email'"
        />
        <span class="text-danger text-sm" v-show="errors.has('To')">{{
          errors.first("To")
        }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>CC Email (can be multiples, separated by comma)</label>
        <vs-input class="inputx w-full" name="CC" v-model="data_local.cc" />
        <span class="text-danger text-sm" v-show="errors.has('CC')">{{
          errors.first("CC")
        }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>BCC Email (can be multiples, separated by comma)</label>
        <vs-input class="inputx w-full" name="BCC" v-model="data_local.bcc" v-validate="'email'" />
        <span class="text-danger text-sm" v-show="errors.has('BCC')">{{ errors.first('BCC') }}</span>
      </div>
    </div>


    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>Status</label>
        <vs-switch v-model="data_local.Status">
          <span slot="true">True</span>
          <span slot="false">False</span>
        </vs-switch>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/1 w-full mt-5">
        <div class="mail-tmplt-btns">
          <label>Body</label>
          <div class="tmplt-btn-wrap">
            <a
              class="right-off-radius"
              @click="showRawJson = showRawJson ? false : true"
              >{{ showRawJson ? "Hide Json" : "Show Json" }}</a
            >
            <a
              class="right-off-radius"
              @click="showRawHtml = showRawHtml ? false : true"
              >{{ showRawHtml ? "Editor" : "Code" }}</a
            >
            <a
              class="off-after"
              @click="showPreviewHtml = showPreviewHtml ? false : true"
              >{{ showPreviewHtml ? "Close" : "Preview" }}</a
            >
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/1 w-full">
        <div class="profile-edit">
          <!-- <quill-editor
            v-if="!showRawHtml && !showPreviewHtml"
            v-model="data_local.html"
            name="html"
          /> -->
          <!--
          <button v-on:click="saveDesign">Save Design</button>
        <button v-on:click="exportHtml">Export HTML</button> -->
          <EmailEditor
            ref="emailEditor"
            v-on:load="editorLoaded"
            v-bind:projectId="projectId"
            v-bind:style="{ minHeight: minHeight }"
            v-if="!showRawHtml && !showPreviewHtml && !showRawJson"
          />
          <vs-textarea
            v-if="showRawHtml && !showPreviewHtml && !showRawJson"
            class="inputx w-full"
            v-model="data_local.html"
            rows="10"
            cols="100"
          />
          <vs-textarea
            v-if="showRawJson && !showRawHtml && !showPreviewHtml"
            class="inputx w-full"
            v-model="data_local.designJson"
            rows="100"
          />
          <div v-if="showPreviewHtml" v-html="data_local.html"></div>
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button v-if="this.data_local.DocName == null"
            class="mt-2"
            id="bckToListing"
            @click="$router.push('/mailtpl/list')"
            >Back To List</vs-button
          >
          <vs-button
            class="ml-auto mt-2"
            @click="before_save"
            :disabled="!validateForm"
            >Save Changes</vs-button
          >
          <vs-button
            class="ml-4 mt-2"
            type="border"
            color="warning"
            @click="reset_data"
            >Reset</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import { EmailEditor } from "vue-email-editor";

import moduleMailtplManagement from "@/store/mailtpl-management/moduleMailtplManagement.js";
import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";
import ls from "@/common/localStorage";

var Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");

export default {
  components: {
    vSelect,
    quillEditor,
    EmailEditor,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    options: Object,
    /*projectId: {
      type: Number,
      default: 6232
    },*/
    /*templateId:{
      type: String,
      default: "17366"
    },*/
    tools: Object,
    appearance: Object,
    locale: String,
    minHeight: {
      type: String,
      default: "500px",
    },
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      imgSrc: this.data.Logo,
      projectId: this.data.projectId,
      attendessList: [],
      ResourceFiles: [],
      showRawHtml: false,
      showPreviewHtml: false,
      disableFromEmail: true,
      client_data: null,
      showRawJson: false,
      IstplExists: false
    };
  },
  computed: {
    status_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.status),
          value: this.data_local.status,
        };
      },
      set(obj) {
        this.data_local.status = obj.value;
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role,
        };
      },
      set(obj) {
        this.data_local.role = obj.value;
      },
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    editorLoaded() {
      let designJson = JSON.parse(this.data_local.designJson);
      this.$refs.emailEditor.editor.loadDesign(designJson);
    },
    saveDesign() {
      this.$refs.emailEditor.editor.saveDesign((design) => {
        console.log("saveDesign", design);
      });
    },
    exportHtml() {
      this.$refs.emailEditor.editor.exportHtml((data) => {
        console.log("exportHtml", data);
      });
    },
    checkTemplateExists(){
      let vm = this;
      if(this.$store.state.mailtplManagement.mailtpls.length && vm.data_local.TemplateName){
        let found = this.$store.state.mailtplManagement.mailtpls.find(element => element.CollectionName == 'Custom' && element.DocName == vm.data_local.TemplateName);
        if(found){          
          this.$vs.notify({
            color: 'warning',
            position: 'top-center',
            text: `${vm.data_local.TemplateName} is already exists, try other!`
          });
          vm.data_local.TemplateName = null;
        }
      }
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes();
        }
      });
    },

    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    save_changes() {
      /* eslint-disable */
      if (!this.validateForm) return;

      this.$vs.loading();
      let DocName;
      let CollectionName;
      if (this.data_local.DocName != null) {
        DocName = this.data_local.DocName;
        CollectionName = this.data_local.CollectionName;
      } else {
        DocName = this.$route.params.DocName;
        CollectionName = this.$route.params.CollectionName;
      }

      let data_local = this.data_local;
      //alert(Id);
      if (DocName && CollectionName) {
        this.$refs.emailEditor.editor.exportHtml((data) => {
          data_local.html = data.html;
          data_local.designJson = JSON.stringify(data.design);
          console.log(DocName);
          console.log(CollectionName);
          console.log(data_local);
          this.$store
            .dispatch("mailtplManagement/updateMailtpl", {
              DocName: DocName,
              CollectionName: CollectionName,
              data: data_local,
            })
            .then((res) => {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Mailtpl",
                text: res.message,
              });
              this.$vs.loading.close();
               this.$router.push('/mailtpl/list');
            });
        });
      } else {
        this.$refs.emailEditor.editor.exportHtml((data) => {
          data_local.html = data.html;
          data_local.designJson = JSON.stringify(data.design);
          this.$store.dispatch('mailtplManagement/addMailtpl', { 
            data: this.data_local, 
            DocName: this.data_local.TemplateName,
            CollectionName: 'Custom'
          })
          .then(res => { 
            this.$vs.notify({
              color: 'success',
              position: 'top-center',
              title: 'Mailtpl',
              text: res.message
            })
            this.$vs.loading.close() 
            if (res.status == 200) {          
              this.$router.push('/mailtpl/list');             
            }            
          }) 
          .catch(err => {          
            this.$vs.notify({
              color: 'warning',
              position: 'top-center',
              title: 'Mail Template',
              text: "Something went wrong!"
            })
          })
        });
      }
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
      this.imgSrc = this.data.Logo;
    },
    fetch_client_data(ClientId) {
      if (ClientId === undefined) {
        ClientId = null;
      }
      this.$store
        .dispatch("clientManagement/fetchClient", ClientId)
        .then((res) => {
          this.client_data = res.data;
          if (this.client_data.CustomSMTP) {
            //this.data_local.from = this.client_data.SMTPServerAddress
            this.disableFromEmail = false;
          } //else this.data_local.from = "noreply@mail.e2m.live";
        });
    },
  },
  created() {
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
    this.fetch_client_data(Session_Client_Id);
    this.$store.dispatch("mailtplManagement/fetchMailtpls");
  },
};
</script>
